import { z } from 'zod';

export const declineRequestSchema = z.object({
  reason: z.string().trim().optional(),
});

export type IDeclineRequestForm = z.infer<typeof declineRequestSchema>;
